module.exports = {
  "/": {
    "name": "idle",
    "success": {
      "default": [
        "IDLE_LOADED"
      ],
      "missing-access": [
        "WAITING_FOR_REDIRECT"
      ]
    }
  },
  "/chat": {
    "name": "chat",
    "success": {
      "default": [
        "CHAT_LOADED"
      ]
    },
    "error": [
      "THREAD_FETCH_FAILURE",
      "CHAT_FETCH_FAILURE"
    ]
  },
  "/missing-access": {
    "name": "missing-access",
    "success": {
      "default": [
        "MISSING_ACCESS_LOADED"
      ]
    }
  },
  "/suggested-prompts": {
    "name": "suggested-prompts",
    "success": {
      "default": [
        "SUGGESTED_PROMPTS_LOADED"
      ]
    },
    "error": [
      "SUGGESTED_PROMPTS_LOAD_FAILURE"
    ]
  },
  "/threads": {
    "name": "threads",
    "success": {
      "default": [
        "THREADS_LOADED"
      ]
    },
    "error": [
      "THREAD_FETCH_FAILURE"
    ]
  }
};